/* PRODUCTION ENVIRONMENT - source of truth for production credentials.
 *
 * This file is COPIED to ./info.tsx by:
 *   - npm run dev:prod     (forces this file to win)
 *   - npm run env:prod     (switch without starting Vite)
 *   - ./deploy.sh production
 *
 * Edit ONLY this file (and info.demo.tsx) to update credentials.
 * Never edit info.tsx directly -- it is gitignored and gets clobbered.
 */

export const projectId = "eirnvzhyhfinzpcqywjt";
export const publicAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVpcm52emh5aGZpbnpwY3F5d2p0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA5MzMxMTksImV4cCI6MjA3NjUwOTExOX0.xSSD6VXl5NRlVkM1Vkca103nBHq46D-s6L5BG4M9Tp8";
export const envName = "production" as const;

// Loud, single-line startup banner so the developer can never be confused
// about which backend localhost:5173 is currently wired to. Runs once when
// info.tsx is first imported (which is the very first thing the app does).
// Suppressed under vitest (MODE === "test") so unit/component tests don't
// pollute their stdout.
if (
  typeof window !== "undefined" &&
  (import.meta as any).env?.MODE !== "test"
) {
  console.log(
    `%c[ENV] PathKit frontend → ${envName} backend (project: ${projectId})`,
    "color:#b91c1c;font-weight:bold",
  );
}
